import PageTitle from "app/components/React/PageTitle/PageTitle";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { SubNav } from "app/components/sub-navigation-bar/SubNav";
import { SegmentsUtils } from "app/services/segments/SegmentsUtils";
import SegmentsQueryBar from "app/pages/segments/querybar/SegmentsQueryBar";
import { SegmentsResponsiveFilters } from "app/pages/segments/SegmentsResponsiveFilters";
import { proNavigator } from "single-spa/react-app/ProNavigator";
import { PreferencesService } from "app/services/preferences/preferencesService";
import { EDUCATION_BAR_PREFERENCES_KEY } from "app/components/educationbar/educationHook";
import { EducationContainer } from "app/components/educationbar/educationContainer";

declare const window;

export const SegmentsSubNav: FC = () => {
    const isMidTierUser = SegmentsUtils.isMidTierUser();
    const [hideEducationComponent, setHideEducationComponent] = useState(null);
    useEffect(() => {
        setHideEducationComponent(PreferencesService.get(EDUCATION_BAR_PREFERENCES_KEY) || false);
    }, []);
    const pageStateObj = proNavigator.current();
    const educationData = window.education?.[pageStateObj?.stateNameForEductionBar || pageStateObj.name];
    const onCloseEducationComponent = () => {
        PreferencesService.add({ [EDUCATION_BAR_PREFERENCES_KEY]: true });
        setHideEducationComponent(true);
    };
    const onEducationIconClick = () => {
        if (hideEducationComponent) {
            PreferencesService.add({ [EDUCATION_BAR_PREFERENCES_KEY]: false });
            setHideEducationComponent(false);
        }
    };

    return (
        <SubNav
            topLeftComponent={<SegmentsQueryBar isMidTierUser={isMidTierUser} />}
            bottomLeftComponent={
                <PageTitle
                    showEducationIcon={educationData ? hideEducationComponent : null}
                    onEducationIconClick={onEducationIconClick}
                />
            }
            bottomRightComponent={<SegmentsResponsiveFilters />}
            education={
                !hideEducationComponent ? (
                    <EducationContainer onCloseEducationComponent={onCloseEducationComponent} />
                ) : null
            }
        />
    );
};
